var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3594 20.1406V15.1406H26V20.1406H24.3594ZM7.64062 11V34.3594H31V37.6406H7.64062C6.75521 37.6406 5.97396 37.3281 5.29688 36.7031C4.67188 36.026 4.35938 35.2448 4.35938 34.3594V11H7.64062ZM16 16.8594V15.1406H17.6406V16.8594H16ZM35.1406 15.1406V12.6406H30.1406V22.6406H32.6406V19.3594H35.1406V16.8594H32.6406V15.1406H35.1406ZM28.5 20.1406V15.1406C28.5 14.4635 28.2656 13.8906 27.7969 13.4219C27.3281 12.901 26.7292 12.6406 26 12.6406H21.8594V22.6406H26C26.7292 22.6406 27.3281 22.4062 27.7969 21.9375C28.2656 21.4167 28.5 20.8177 28.5 20.1406ZM20.1406 16.8594V15.1406C20.1406 14.4635 19.8802 13.8906 19.3594 13.4219C18.8906 12.901 18.3177 12.6406 17.6406 12.6406H13.5V22.6406H16V19.3594H17.6406C18.3177 19.3594 18.8906 19.125 19.3594 18.6562C19.8802 18.1354 20.1406 17.5365 20.1406 16.8594ZM34.3594 4.35938C35.2448 4.35938 36 4.69792 36.625 5.375C37.3021 6 37.6406 6.75521 37.6406 7.64062V27.6406C37.6406 28.526 37.3021 29.3073 36.625 29.9844C36 30.6615 35.2448 31 34.3594 31H14.3594C13.474 31 12.6927 30.6615 12.0156 29.9844C11.3385 29.3073 11 28.526 11 27.6406V7.64062C11 6.75521 11.3385 6 12.0156 5.375C12.6927 4.69792 13.474 4.35938 14.3594 4.35938H34.3594Z",
    fill: "#9497A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfEmpty);
export default __webpack_public_path__ + "static/media/pdf-empty.b80b05320c107a658428b2ef2894e459.svg";
export { ForwardRef as ReactComponent };